/**
 * @generated SignedSource<<293d499790c0a501a892a65f67499aaa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
import { FragmentRefs } from "relay-runtime";
export type PatientFragment$data = {
  readonly __typename: string;
  readonly address: {
    readonly city: string;
    readonly country: {
      readonly code: string;
      readonly countryLookupTranslations: ReadonlyArray<{
        readonly countryIsoCode2: string;
        readonly countryName: string;
        readonly language: string;
      }>;
      readonly id: string;
    } | null;
    readonly countryCode: string;
    readonly houseNumberStreet: string;
    readonly postalCode: string;
  } | null;
  readonly age: {
    readonly days: number;
    readonly isMajor: boolean;
    readonly months: number;
    readonly weeks: number;
    readonly years: number;
  };
  readonly birthDate: any;
  readonly contactChannel: ContactChannel;
  readonly country: Country;
  readonly displayId: number;
  readonly emailAddress: string | null;
  readonly firstName: string;
  readonly gender: Gender;
  readonly id: string;
  readonly isContactChannelVerified: boolean;
  readonly isEligibleForPreventionProgram: boolean;
  readonly lastName: string;
  readonly patientFileLock: {
    readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockFragment" | "PatientFileLockFragmentInline">;
  };
  readonly patientId: string;
  readonly phoneNumber: string | null;
  readonly primaryLanguage: Language;
  readonly secondaryLanguages: ReadonlyArray<Language>;
  readonly " $fragmentType": "PatientFragment";
};
export type PatientFragment$key = {
  readonly " $data"?: PatientFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatientFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "birthDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CountryLookup",
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": "code",
              "args": null,
              "kind": "ScalarField",
              "name": "countryIsoCode2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CountryLookupTranslation",
              "kind": "LinkedField",
              "name": "countryLookupTranslations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryIsoCode2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "countryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "language",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "houseNumberStreet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postalCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryLanguage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryLanguages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Age",
      "kind": "LinkedField",
      "name": "age",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "years",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "months",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weeks",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "days",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMajor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientFileLock",
      "kind": "LinkedField",
      "name": "patientFileLock",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PatientFileLockFragment"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "PatientFileLockFragmentInline",
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockedBy",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockRequestedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockRequestedBy",
              "storageKey": null
            },
            {
              "alias": "inContextOfAppointment",
              "args": null,
              "concreteType": "Appointment",
              "kind": "LinkedField",
              "name": "appointment",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requestInContextOfAppointmentId",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEligibleForPreventionProgram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isContactChannelVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactChannel",
      "storageKey": null
    }
  ],
  "type": "Patient",
  "abstractKey": "__isPatient"
};
})();

(node as any).hash = "825273a103b6aa7814c754dfe4b61694";

export default node;
